import React from 'react';
import {
  FDPaper, FDBodyText, FDLozenge, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import BodyList from 'Components/ComponentLibrary/Molecules/BodyList';
import { DataValueMap } from 'Helpers/Testing';

const ScenarioSelectionRedefinedPostSelectionNextUpRefreshContent = ({ resource }) => {
  const alteredScheduledTransferGroups = resource.attr('alteredScheduledTransferGroups').resources().list();

  if (alteredScheduledTransferGroups.length === 0) {
    return null;
  }

  return (
    <FDPaper appearance={'flat'} padding={3} {...DataValueMap.init('scenario-selection-redefined-wizard-next-up-refresh-step-content').build()}>
      <FDStack direction={'column'} spacing={4}>
        {
            alteredScheduledTransferGroups.map((group) => {
              return (
                <FDStack direction={'column'} spacing={4} key={group.id()} {...DataValueMap.init(`altered-scheduled-transfer-group-${group.attr('groupType')}`).build()}>
                  <FDLozenge label={group.attr('groupType')} color={'error'} />
                  <FDStack direction={'column'} spacing={2}>
                    <FDBodyText size={'lg'} value={group.attr('groupDescriptionTitle')} />
                    <BodyList value={group.attr('groupDescriptionDetails')} size={'lg'} />
                  </FDStack>
                </FDStack>
              );
            })
          }
      </FDStack>
    </FDPaper>
  );
};

ScenarioSelectionRedefinedPostSelectionNextUpRefreshContent.defaultProps = {
};

ScenarioSelectionRedefinedPostSelectionNextUpRefreshContent.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ScenarioSelectionRedefinedPostSelectionNextUpRefreshContent;
